import { render, staticRenderFns } from "./widgetSecThreatCategory.vue?vue&type=template&id=0ed8dcb5&scoped=true&"
import script from "./widgetSecThreatCategory.vue?vue&type=script&lang=js&"
export * from "./widgetSecThreatCategory.vue?vue&type=script&lang=js&"
import style0 from "./widgetSecThreatCategory.vue?vue&type=style&index=0&id=0ed8dcb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8dcb5",
  null
  
)

export default component.exports